/**
 * Registry — mapa motor -> classe.
 *
 * Todos os 9 motores da secao 5 sao registrados aqui, implementados ou nao.
 * Este arquivo e a unica fonte de verdade de "que motores existem no codigo".
 * O validador de conteudo cruza esta lista com /conteudo/motores.json.
 */

import { ContarEngine } from '../engines/ContarEngine.js';
import { CompararEngine } from '../engines/CompararEngine.js';
import { DistribuirEngine } from '../engines/DistribuirEngine.js';
import { ClassificarEngine } from '../engines/ClassificarEngine.js';
import { SeriarEngine } from '../engines/SeriarEngine.js';
import { SequenciarEngine } from '../engines/SequenciarEngine.js';
import { EscolherEngine } from '../engines/EscolherEngine.js';
import { PalpitarEngine } from '../engines/PalpitarEngine.js';
import { ConstruirEngine } from '../engines/ConstruirEngine.js';

export const MOTORES = Object.freeze({
  contar: ContarEngine,
  comparar: CompararEngine,
  distribuir: DistribuirEngine,
  classificar: ClassificarEngine,
  seriar: SeriarEngine,
  sequenciar: SequenciarEngine,
  escolher: EscolherEngine,
  palpitar: PalpitarEngine,
  construir: ConstruirEngine,
});

/**
 * Devolve a classe do motor pedido.
 * Falha alto e em portugues se o motor nao existir — sem catch silencioso.
 */
export function obterMotor(nome) {
  const Classe = MOTORES[nome];
  if (!Classe) {
    throw new Error(
      `FAZENDA: o motor "${nome}" nao existe no Registry.js. ` +
        `Motores registrados: ${Object.keys(MOTORES).join(', ')}. ` +
        `Confira o campo "motor" do JSON da tarefa.`
    );
  }
  return Classe;
}
